import React, { useState, useEffect, useRef } from "react";
import { Link } from 'react-router-dom';
import { Box, Button, Pagination, Section } from 'react-bulma-components';
import { Trash2 } from 'react-feather';

//Components
import { Thumbnail } from "shared/components/user";
import { AddUserPanel } from "shared/components/user";

// actions & utils
import { makeAPIRequest } from "shared/state/fetch";
import { useTokenStatus } from "shared/state/auth/actions";
import { getUserInitials } from "shared/utils";

// styles
import styles from './settings/Settings.module.scss';

const Users = () => {
    const [usersList, setUsersList] = useState([]);
    const [pagination, setPagination] = useState([]);
    const [addNewUser, setAddNewUser] = useState(false);
    const [paged, setPaged] = useState(1);
    const [isLoading, setIsLoading] = useState(true);
    const { handleTokenStatus } = useTokenStatus();
    const isMounted = useRef(null);

    useEffect(() => {
        isMounted.current = true;
        const query = `users?page=${paged}`;

        makeAPIRequest(query)
            .then(response => {
                if (isMounted.current) {
                    setIsLoading(false);
                    setPagination(response.result.meta);
                    setUsersList(response.result.data);
                    response.status && handleTokenStatus(response);
                }
            }
        );

        return () => {
            // executed when unmount
            isMounted.current = false;
        }
    }, [paged]);

    const onClickNewUser = () => {
        setAddNewUser(true);
    }

    const handleOnAddNewUser = (user) => {
        makeAPIRequest('users', 'POST', user)
            .then(response => {
                console.log('response ' , response);
                handleClose();
                response.status && handleTokenStatus(response);
            }
        )
    }

    const handleRemoveUser = (user) => {
        console.log('You are about to remove ', user);
    }

    const handlePageChange = (e) => {
        setPaged(e);
    }

    const handleClose = () => {
        setAddNewUser(false);
    }

    return (

        <>
        { !isLoading &&
            <AddUserPanel
                isActive={ addNewUser }
                onClose={ handleClose }
                onAddNewUser={ handleOnAddNewUser } />
        }
            <div className={ styles.users }>
                <div className="pageHeading">
                    <h1>User Management</h1>
                    <Button size="small" className="gradient" onClick={ onClickNewUser }>
                        NEW USER
                    </Button>
                </div>
                { (!usersList || usersList.length === 0) && !usersList && <p>No Users to display</p> }
                { usersList && usersList.length > 0 &&
                    <table className="table is-hoverable is-fullwidth">
                        <thead>
                            <tr>
                                <td></td>
                                <td>Name</td>
                                <td>Email</td>
                                <td>Role</td>
                                <td>Updated at</td>
                                <td>Status</td>
                                <td></td>
                            </tr>
                        </thead>

                        <tbody>
                            { usersList.map((user, index) => {
                                const initials = getUserInitials(user.name, user.surname);

                                return <tr key={ index }>
                                    <td style={{paddingLeft: '5rem', verticalAlign: 'middle'}}>
                                        <Thumbnail
                                            initials={ initials }
                                            image={ user.image }
                                            backgroundColor="#B3B5BD" />
                                    </td>
                                    <td className={ styles.name } style={{ verticalAlign: 'middle' }}>
                                        { user.name } { user.surname }
                                    </td>
                                    <td>
                                        { user.email }
                                    </td>
                                    <td className={ styles.role }>
                                        <Button
                                            className={ styles[user.role] }
                                            fullwidth>
                                            { user.role }
                                        </Button>
                                    </td>
                                    <td>
                                        { user.updated_at }
                                    </td>
                                    <td>
                                        <span style={{ marginLeft: '0.5rem'}} className={ `${user.status === 1 ? "has-text-success" : "has-text-danger"}`}>
                                            { user.status === 1 ? 'Active': 'Inactive' }
                                        </span>
                                    </td>
                                    <td className="has-text-right"
                                        style={{ paddingRight: '5rem', verticalAlign: 'middle'}}>
                                        <Button className={ styles.delete } color="ghost" onClick={ ()=> handleRemoveUser(user) }>
                                            <Trash2 size={16} strokeWidth={1.5} className={ styles.icon } />
                                        </Button>
                                    </td>
                                </tr>
                            })}
                        </tbody>
                        <tfoot>
                        </tfoot>
                    </table>
                }
                { pagination &&
                    <Pagination
                        align="center"
                        autoHide
                        className={ styles.pagination }
                        current={ pagination.current_page }
                        onChange={ handlePageChange }
                        showPrevNext={false}
                        rounded
                        total={ pagination.last_page} />
                }
            </div>
        </>
    );
}

export default Users;
